import React from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { useIsMobileDimension } from '@beef/ui-kit';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Title = function Title(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    isCentered = _ref.isCentered;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper'),
    "data-t-id": "components-Title"
  }, /*#__PURE__*/React.createElement(Text, {
    align: isCentered ? 'center' : undefined,
    color: "primary",
    variant: isMobile ? 'display-small' : 'display-large'
  }, title), subtitle && /*#__PURE__*/React.createElement(Text, {
    align: isCentered ? 'center' : undefined,
    color: "secondary",
    variant: "body-medium"
  }, subtitle));
};